import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import oldTheme from '../../Colors';

export const Content = styled.div`
  padding-right: ${props => props.theme.spacing(2)};
  display: flex;
  align-items: center;
  line-height: 1.875rem;

  &:last-child {
    padding-right: 0;
  }
`;

export const Item = props => (
  <li className={props.className}>
    {React.Children.map(props.children, child => (
      <Content>{child}</Content>
    ))}
  </li>
);

Item.propTypes = {
  /** injects the generated stylesheet */
  className: PropTypes.string,
  /** all component children nodes */
  children: PropTypes.node,
};

export default styled(Item)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${props =>
    props.delimiter &&
    css`
      border-bottom: 1px solid ${oldTheme.colors.modern.list.itemStroke};
    `};
`;
